import { Avatar, Box, Button, Container, Divider, Paper, TextField, Typography } from '@mui/material';
import React, { useReducer, useState, useEffect, useRef } from 'react';
import { formatPrice, objectToFormData } from '../../../utils/utils';
// import PropTypes from 'prop-types';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { emptyCart } from '../../../redux/actions/cartactions';
import httpClient from '../../../services/http';
import { APIUtils } from '../../../utils/apiutils';
import Swal from 'sweetalert2';
import { TEST_COLLECTIONS } from '../labtest/constants';
import TreatuLogo from '../../../assets/logos/treatu_logo.png';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../components/spinner/spinner';
import { USER_ROLES } from '../../../utils/constants';
import './cart.page.css';

const PlaceOrder = () => {
    const navigate = useNavigate();
    const ORDER_STATES = {
        patientName: '',
        patientNumber: '',
        patientAge: '',
        prescription: '',
    };
    const [placingOrder, setPlacingOrder] = useState(false);
    const {cart, orderInfo} = useSelector(state => state.cart);
    const userState = useSelector(state => state.auth.user);
    const [cartOrderData, updateCartOrderData] = useReducer((prev, next) => ({...prev, ...next}), ORDER_STATES);
    const cartPrice = cart.reduce((acc, curr) => +curr.price + acc, 0);
    const serviceType = Object.hasOwn(orderInfo, 'collectionType') ? TEST_COLLECTIONS.find(coll => coll.value === orderInfo.collectionType).name || '' : '';
    const testIds = JSON.stringify(cart.map(test => test.id));
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [fileType, setFileType] = useState(null);

    const fileRef = useRef();

    const handleOrderState = (e) => {
        const {name, value} = e.target;
        updateCartOrderData({[name]: value});
    };

    const createTestRequest = async (requestData) => {
        try {
            const payload = {...requestData, testIds};
            if (file) {
                payload.prescription = file;
            }
            if (orderInfo.coordinate) {
                payload.coordinate = JSON.stringify(orderInfo.coordinate);
            }
            if (orderInfo.city) {
                payload.city = orderInfo.city;
            }
            const formData = objectToFormData(payload);
            const res = await httpClient.post(APIUtils.getAPIEndpoint('create-test-request'), formData);
            // testRequestData
            console.log({res});
            emptyCart();
            navigate('/my-requests');
        } catch (error) {
            console.log(error);
            Swal.fire('Something Went Wrong while updating your order status!', '', 'error');
        }
    };

    const isLoginValid = () => {
        if (userState && userState.role && userState.role === USER_ROLES.PATIENT) {
            return true;
        }

        return false;
    };

    const handlePlaceOrder = async () => {
        if (!isLoginValid()) {
            Swal.fire('Sorry!', 'Please, login before you place your order.', 'error');
            return;
        }
        if (orderInfo?.testType === 1 && !file) {
            Swal.fire('Please upload Prescription.', 'error');
            return;
        }
        setPlacingOrder(true);
        const { patientName, patientAge, patientNumber } = cartOrderData;
        const payload = {
            amount: cartPrice,
            description: 'Tests for patients',
            productName: 'Lab Tests',
            email: userState.email,
            contact: patientNumber,
            personName: patientName,
            patientInfo: JSON.stringify({ patientName, patientAge, patientNumber }),
            testServiceType: serviceType,
            requestFor: 'Pathology Lab',
            testdatetime: orderInfo.testDate,
            location: orderInfo.selectedLocation,
        };
        try {
            const orderData = await httpClient.post(APIUtils.getAPIEndpoint('create-request-order'), payload);
            const res = orderData?.data;
            if (res?.success) {
                const options = {
                    key: res.keyId,
                    amount: res.amount,
                    currency: 'INR',
                    name: res.product_name,
                    description: res.description,
                    image: TreatuLogo,
                    'order_id': res.orderId,
                    prefill: {
                        contact: res.contact,
                        name: res.name,
                        email: res.email
                    },
                    notes: {
                        description: res.description
                    },
                    theme: {
                        color: '#2300a3'
                    },
                    handler: response => {
                        console.log(response, 'response');
                        // if (response.status_code === 200) {
                        Swal.fire('Payment Success!', '', 'success');
                        createTestRequest({...payload, paymentStatus: 'PAID'});
                        // } else {
                        //     Swal.fire('Payment Failed!', '', 'error');
                        // }
                    }
                };
                const razorpayObject = new window.Razorpay(options);
                razorpayObject.open();
            }
        } catch (error) {
            console.log(error);
            Swal.fire('Something Went Wrong!', '', 'error');
            createTestRequest(payload);
        } finally {
            Swal.hideLoading();
            setPlacingOrder(false);
        }
    };

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        if (fileData) {
            setFile(fileData);
            const type = fileData.type;
            setFileType(type);

            if (
                type === 'image/png' ||
                type === 'image/jpeg' ||
                type === 'image/jpg' ||
                type === 'application/pdf'
            ) {
                const url = URL.createObjectURL(fileData);
                setPreviewUrl(url);
            } else {
                setPreviewUrl(null);
            }
        }
    };

    const selectPrescription = () => {
        fileRef.current.click();
    };

    const deselectFile = () => {
        setFile(null);
        setPreviewUrl(null);
        setFileType(null);
    };
    useEffect(() => {
        if (!userState) {
            return;
        }
        const patientName = userState.middleName ? `${userState.firstName} ${userState.middleName} ${userState.lastName}` : `${userState.firstName} ${userState.lastName}`;
        updateCartOrderData({
            patientAge: userState.age,
            patientName,
            patientNumber: userState.mobileNumber,
        });
    }, [userState]);

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    const testServiceType = Object.hasOwn(orderInfo, 'collectionType') && <Typography><strong>Test Service Type: </strong>{serviceType}</Typography>;

    const prescriptionSelector = (
        <div className="flex-gap" style={{marginTop: '1rem'}}>
            <Box className="prescription-upload-wrapper">
            {!previewUrl && (
                <Avatar sx={{ height: 64, width: 64}} style={{cursor: 'pointer'}} onClick={selectPrescription}>
                    <PhotoCameraIcon />
                    <input
                        type='file'
                        accept='image/png, application/pdf, image/jpeg'
                        hidden={true}
                        onChange={handlePrescription}
                        ref={fileRef}
                    />
                </Avatar>
            )}
                <p className={`descriptor ${orderInfo?.testType === 1 ? 'required-label' : ''}`}>Upload</p>
                {previewUrl && (
                <Box mt={2}>
                    {fileType === 'application/pdf' ? (
                        <iframe
                            src={previewUrl}
                            title="PDF Preview"
                            width="80%"
                            height="100px"
                            style={{ border: '1px solid #ccc' }}
                        />
                    ) : (
                        <img
                            src={previewUrl}
                            alt="Preview"
                            style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
                        />
                    )}
                </Box>
            )}
            </Box>
            {
                file && <p className='selected-prescription'>
                    {file.name}
                    <CloseIcon onClick={deselectFile} />
                </p>
            }
        </div>
    );

    const placeOrderBtn = () => {
        if (placingOrder) {
            return <Button variant='contained' className='small-brown-btn'>Placing Order&nbsp;<Spinner /></Button>;
        }
        return <Button variant='contained' className='small-brown-btn' onClick={handlePlaceOrder}>Place Order</Button>;
    };
    return (
        <Box className='place-order-container'>
            <Typography className='ext-large-brown-txt' style={{textAlign: 'left'}}>
                Place Order
            </Typography>
            <div className="place-order-content flex-gap">
                <Paper className='patient-info-container'>
                    <div className="patient-info-content place-order-info-box">
                        <Typography variant="h6">Patient Info</Typography>
                        <Divider />
                        <Box>
                            <TextField fullWidth label="Patient Name" placeholder='Name' variant="outlined" value={cartOrderData.patientName} onChange={handleOrderState} name='patientName' />
                        </Box>
                        <Box>
                            <TextField fullWidth label="Phone Number" placeholder='Phone Number' variant="outlined" value={cartOrderData.patientNumber} onChange={handleOrderState} name='patientNumber' />
                        </Box>
                        <Box>
                            <TextField fullWidth label="Age (in years)" placeholder='Age' variant="outlined" value={cartOrderData.patientAge} onChange={handleOrderState} name='patientAge' />
                        </Box>
                    </div>
                    <div className="place-order-info-box">
                        {/* if testType is 1 then this customer have prescription and  */}
                        <Typography variant="h6">Previous Medical Document/Prescriptions</Typography>
                        <Divider />
                        {prescriptionSelector}
                    </div>
                    <div className="place-order-info-box">
                        <Divider />
                        <div className='cart-step-actions'>{placeOrderBtn()}</div>
                    </div>
                </Paper>
                <Paper className="order-info-container place-order-info-box">
                    <Typography variant="h6">Order Info</Typography>
                    <Typography><strong>Request For: </strong>{orderInfo?.orderType ? orderInfo.orderType : 'Pathology Lab'}</Typography>
                    {testServiceType}
                    <Typography>{cart.length} item(s) has been added</Typography>
                    <Typography><strong>Total Price: </strong>{formatPrice(cartPrice)}</Typography>
                    <Divider />
                    <div className='space-between'>
                        <Typography variant="h6">Total Amount</Typography>
                        <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                    </div>
                    <div className='space-between'>
                        <Typography variant="h6">Total Payable Amount</Typography>
                        <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                    </div>
                </Paper>
            </div>
        </Box>
    );
};

// const CartItem = ({name, description, price, itemIndex}) => {
//     const handleRemoveItem = () => {
//         removeFromCart(itemIndex);
//     };

//     return (
//         <div className='cart-item-container'>
//             <div className="cart-item-content space-between">
//                 <div className="cart-item-data">
//                     <Typography variant="h6">{name}</Typography>
//                     <Typography>{description}</Typography>
//                 </div>
//                 <div className="cart-item-price">
//                     <Typography variant="h6">{formatPrice(price)}</Typography>
//                 </div>
//             </div>
//             <div className="cart-item-action">
//                 <Button onClick={handleRemoveItem}>Remove</Button>
//             </div>
//         </div>
//     );
// };
// CartItem.propTypes = {
//     name: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     price: PropTypes.number.isRequired,
//     itemIndex: PropTypes.number.isRequired,
// };

// const ConfirmOrder = () => {
//     const {cart} = useSelector(state => state.cart);
//     // const CART_ITEMS = [
//     //     {
//     //         id: 1,
//     //         name: 'Fasting Blood Sugar',
//     //         description: 'Pre-Test Information: - EMPTY STOMACH',
//     //         price: 70
//     //     },
//     // ];

//     const cartContent = () => {
//         if (cart.length < 1) {
//             return (
//                 <div className='empty-cart-container'>Cart is empty</div>
//             );
//         }

//         const cartItems = cart.map((cartItem, i) => <CartItem key={cartItem.id} {...cartItem} itemIndex={i} />);
//         const cartPrice = cart.reduce((acc, curr) => +curr.price + acc, 0);
//         const cartTotals = (
//             <div className='cart-totals-container'>
//                 <div className='flex-gap'>
//                     <Typography variant='h6'>Cart Totals:</Typography>
//                     <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
//                 </div>
//             </div>
//         );

//         return (
//             <div className='confirm-order-container'>
//                 <Typography variant="h6">Service Information</Typography>
//                 <Box className="space-between">
//                     <Typography variant="h6">Pathology Lab test</Typography>
//                     <div>Date: {formatDate2(new Date())}</div>
//                 </Box>
//                 {cartItems}
//                 <Divider />
//                 {cartTotals}
//             </div>
//         );
//     };
//     return (
//         <Box>
//             <Typography className='ext-large-brown-txt' style={{textAlign: 'left'}}>
//                 My Cart
//             </Typography>
//             {cartContent()}
//         </Box>
//     );
// };

const CartPage = () => {
    // const {cart} = useSelector(state => state.cart);
    // const [cartStep, setCartStep] = useState(0);

    // const handleConfirm = () => {
    //     setCartStep(1);
    // };

    // const cartPageContent = () => {
    //     const confirmBtn = cart.length > 0 && (
    //         <div className='cart-step-actions'>
    //             <Button variant='contained' className='small-brown-btn' onClick={handleConfirm}>Confirm</Button>
    //         </div>
    //     );

    //     const confirmOrderUI = (
    //         <>
    //             <ConfirmOrder />
    //             {confirmBtn}
    //         </>
    //     );

    //     switch (cartStep) {
    //         case 1:
    //             return <PlaceOrder />;

    //         default:
    //             return confirmOrderUI;
    //     }
    // };
    return (
        <Container className='doc-cat-content labtest-page'>
            <div className='cart-page-content'>
                {/* {cartPageContent()} */}
                <PlaceOrder />
            </div>
        </Container>
    );
};

export default CartPage;